import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-store-unpublish-alert',
  templateUrl: './store-unpublish-alert.component.html',
  styleUrls: ['./store-unpublish-alert.component.scss']
})
export class StoreUnpublishAlertComponent implements OnInit {

  alertData: any = {
    heading:'Your store is currently unpublished',
    message:'Publish it now to start attracting customers and boost your sales!'
  };
  @Input() onDdashboard: boolean = false;

  @Output() closed = new EventEmitter<void>();

  visible: boolean = true;
  private storageKey = 'unpublished-alert-hidden';

  constructor() { }

  ngOnInit(): void {
    const status = localStorage.getItem(this.storageKey);
    this.visible = status !== 'true';
  }

  closeAlert(): void {
    this.visible = false;
    localStorage.setItem(this.storageKey, 'true');
    this.closed.emit();
  }

}
